export default "__VITE_PUBLIC_ASSET__5c7cbd1d__"